@use "@fukuri-admins/ui/layout" as *;

.TableFooter {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;

  @media screen and (max-width: $TB) {
    background-color: background('Primary');
    padding: 24px 0;
    margin-top: 0;
  }

  &__PerPageRoot {
    display: flex;
    align-items: center;
    
    &__PerPageText {
      color: $NATURAL_400;
      font-size: 16px;
      font-weight: 600;
    }
  }

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
  }
}
